import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import postClockInHost from 'Api/host-attendance-record/postClockInHost';

import { useStatusState } from 'Store/status-state';
import { useToast } from 'Store/toast';
import postClockInHostRequest from 'Domain/host-attendance-record/model/request/postClockInHostRequest';
import { useHostAttendanceRecordState } from 'View/host-attendance-record/state';

const usePostClockInHost = () => {
  const { t } = useTranslation('host-attendance');
  const navigate = useNavigate();
  const { onOpenStatusState } = useStatusState();
  const { onOpenToast } = useToast();
  const { updateState } = useHostAttendanceRecordState();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = await postClockInHostRequest(formData);

      const result = await postClockInHost(payload);

      return result;
    },
    onSuccess: async (result) => {
      if (result?.data?.violationTypes?.length > 0) {
        onOpenStatusState({
          type: 'warning',
          title: t('violation_detected.title'),
          description: t('violation_detected.description.clock_in'),
          violations: result?.data?.violationTypes,
          lateClockInMinutes: result?.data?.lateClockInMinutes || 0,
          primaryButtonLabel: t('success_clock_in.view_brief'),
          onClick: () => navigate('/host/brief-live'),
        });
      } else {
        onOpenStatusState({
          type: 'success',
          title: t('success_clock_in.title'),
          description: t('success_clock_in.description'),
          primaryButtonLabel: t('success_clock_in.view_brief'),
          onClick: () => navigate('/host/brief-live'),
        });
      }

      navigate('/host');
    },
    onError: async () => {
      onOpenToast({
        description: t('loading_attendance.process_failed'),
        status: 'failed',
        duration: 5,
        position: 'top',
        type: 'mobile',
      });
    },
    onSettled: async () => {
      updateState({ isLoading: false });
    },
  });
};

export default usePostClockInHost;
